// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ManageOptions.css */

.manage-options-container {
    font-family: Arial, sans-serif;
    padding: 20px;
    background-color: #f5f5f5;
  }
  
  .field-container {
    margin: 20px 0;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .manage-options-container h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }
  
  .manage-options-container h3 {
    font-size: 18px;
    margin-bottom: 10px;
  }
  
.manage-options-container ul {
    list-style: none;
    padding: 0;
    overflow: auto;
    max-height: 9rem;
  }
  
  .option-item {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }
  
  .delete-button {
    background-color: #ff6347;
    color: #fff;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    cursor: pointer;
    margin-top: 1rem;
  }
  
/* Add styles for the "add" button next to the "delete" button */
.add-button {
  background-color: #ff6347;
  color: #fff;
  border: none;
  border-radius: 5px;
  padding: 5px 10px;
  margin: 5px;
  cursor: pointer;
  font-size: 14px;
}

/* Add styles for the "Add New Task Option" dialog */
.add-option-dialog {
  border: 1px solid #ccc;
  padding: 20px;
  margin: 10px 0;
  background-color: #f9f9f9;
}

.cancel-button {
  background-color: #ccc;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */
  z-index: 899; /* Ensure it's above other content */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Add styles for the dialog content */
.add-option-dialog {
  background-color: #fff;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 30%;
  text-align: center;
}

.add-option-dialog h3 {
  font-size: 18px;
  margin: 10px 0;
}

.add-option-dialog label {
  display: block;
  margin-top: 10px;
}

.add-option-dialog input {
  margin-left: 1rem;
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.add-option-dialog .add-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 10px 5px;
  cursor: pointer;
  font-size: 14px;
  margin-top: 1.5rem;
  border-radius: 5px;
}

.add-option-dialog .cancel-button {
  background-color: #f44336;
  color: white;
  border: none;
  padding: 10px 15px;
  margin: 10px 5px;
  cursor: pointer;
  margin-top: 1.5rem;
  font-size: 14px;
  border-radius: 5px;
}

`, "",{"version":3,"sources":["webpack://./src/components/Form/Components/ManageOptions.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,8BAA8B;IAC9B,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;AAEF;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;AAEF,gEAAgE;AAChE;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,sCAAsC;EACtE,YAAY,EAAE,oCAAoC;EAClD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* ManageOptions.css */\n\n.manage-options-container {\n    font-family: Arial, sans-serif;\n    padding: 20px;\n    background-color: #f5f5f5;\n  }\n  \n  .field-container {\n    margin: 20px 0;\n    padding: 10px;\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .manage-options-container h2 {\n    font-size: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .manage-options-container h3 {\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n  \n.manage-options-container ul {\n    list-style: none;\n    padding: 0;\n    overflow: auto;\n    max-height: 9rem;\n  }\n  \n  .option-item {\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n  }\n  \n  .delete-button {\n    background-color: #ff6347;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    padding: 5px 10px;\n    cursor: pointer;\n    margin-top: 1rem;\n  }\n  \n/* Add styles for the \"add\" button next to the \"delete\" button */\n.add-button {\n  background-color: #ff6347;\n  color: #fff;\n  border: none;\n  border-radius: 5px;\n  padding: 5px 10px;\n  margin: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n/* Add styles for the \"Add New Task Option\" dialog */\n.add-option-dialog {\n  border: 1px solid #ccc;\n  padding: 20px;\n  margin: 10px 0;\n  background-color: #f9f9f9;\n}\n\n.cancel-button {\n  background-color: #ccc;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent black background */\n  z-index: 899; /* Ensure it's above other content */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n/* Add styles for the dialog content */\n.add-option-dialog {\n  background-color: #fff;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 30%;\n  text-align: center;\n}\n\n.add-option-dialog h3 {\n  font-size: 18px;\n  margin: 10px 0;\n}\n\n.add-option-dialog label {\n  display: block;\n  margin-top: 10px;\n}\n\n.add-option-dialog input {\n  margin-left: 1rem;\n  padding: 8px;\n  margin-top: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.add-option-dialog .add-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  margin: 10px 5px;\n  cursor: pointer;\n  font-size: 14px;\n  margin-top: 1.5rem;\n  border-radius: 5px;\n}\n\n.add-option-dialog .cancel-button {\n  background-color: #f44336;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  margin: 10px 5px;\n  cursor: pointer;\n  margin-top: 1.5rem;\n  font-size: 14px;\n  border-radius: 5px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
